<span
  class="gw-expand-chevron"
  [class.gw-expand-chevron--open]="expanded"
  aria-hidden="true"
>
  <gatewee-icon icon="@tui.chevron-right" [size]="size"></gatewee-icon>
</span>
